export * from './IconAxisY';
